var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.125C3.65117 0.125 0.125 3.65117 0.125 8C0.125 12.3488 3.65117 15.875 8 15.875C12.3488 15.875 15.875 12.3488 15.875 8C15.875 3.65117 12.3488 0.125 8 0.125ZM8 14.5391C4.38945 14.5391 1.46094 11.6105 1.46094 8C1.46094 4.38945 4.38945 1.46094 8 1.46094C11.6105 1.46094 14.5391 4.38945 14.5391 8C14.5391 11.6105 11.6105 14.5391 8 14.5391Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2344 7.4375H8.5625V4.76562C8.5625 4.68828 8.49922 4.625 8.42188 4.625H7.57812C7.50078 4.625 7.4375 4.68828 7.4375 4.76562V7.4375H4.76562C4.68828 7.4375 4.625 7.50078 4.625 7.57812V8.42188C4.625 8.49922 4.68828 8.5625 4.76562 8.5625H7.4375V11.2344C7.4375 11.3117 7.50078 11.375 7.57812 11.375H8.42188C8.49922 11.375 8.5625 11.3117 8.5625 11.2344V8.5625H11.2344C11.3117 8.5625 11.375 8.49922 11.375 8.42188V7.57812C11.375 7.50078 11.3117 7.4375 11.2344 7.4375Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRounded);
export default __webpack_public_path__ + "static/media/PlusRounded.3267b7f2061886a1e4518820be44014b.svg";
export { ForwardRef as ReactComponent };